import { IntlShape } from 'react-intl/lib';

import { useExternalLinks } from '@/app/hooks/useExternalLinks';
import { SELF_EMPLOYED } from '@/modules/partner/model/partnerType';
import { ICard, ICardContext } from '@/pages/Todo/types';

const ru = (
  context: ICardContext,
  intl: IntlShape,
  links: ReturnType<typeof useExternalLinks>,
): ICard[] => {
  const result: ICard[] = [];

  if (context.partner.partnerType === SELF_EMPLOYED) {
    result.push({
      order: -1,
      id: 'get-a-legal-status',
      cardStatus: 'todo',
      title: intl.formatMessage({
        defaultMessage: 'Register as an IE or OOO',
        id: 'pbmyE5',
        description: 'todo list card text: specific for RU',
      }),
      desc: intl.formatMessage(
        {
          defaultMessage:
            'It usually takes five business days to register as an IE (individual entrepreneur) and 3 business days to open an OOO (limited liability company) from the moment you send in the documents. If your status has already been updated, please contact your <a>manager.</a>',
          id: '7c0dmo',
          description: 'todo list card text: specific for RU',
        },
        {
          a: (text: React.ReactNode) => (
            <a href={links.contactOperationTeam} target="_blank" rel="noreferrer">
              {text}
            </a>
          ),
        },
      ),
      actionTitle: intl.formatMessage({
        defaultMessage: 'Go to ‘Gosuslugi’',
        id: 'LuI/dl',
        description: 'todo list card text: specific for RU',
      }),
      actionExternalLink: links.registerIPorOOO,
    });
  }

  return result;
};

export { ru };
